import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import {getSessionPeople} from 'utils/session-utils';
import * as actionTypes from '../constants/sessions-bulk-update-action-types';

import type {List} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type SessionBulkUpdateStore = {
    locations: List<unknown>;
    loadedLocations: boolean;
    loadedOrgs: boolean;
    loadedPeople: boolean;
    organizations: List<unknown>;
    people: List<unknown>;
};

const initialState = (): SessionBulkUpdateStore => {
    return {
        locations: Immutable.List(),
        loadedLocations: false,
        loadedOrgs: false,
        loadedPeople: false,
        organizations: Immutable.List(),
        people: Immutable.List(),
    };
};

const actionsMap: ActionsMap<SessionBulkUpdateStore> = {
    [actionTypes.GET_LOCATIONS_SUCCESS]: (state, action) => {
        return {
            loadedLocations: true,
            locations: action.data,
        };
    },
    [actionTypes.GET_ORGANIZATIONS_SUCCESS]: (state, action) => {
        return {
            loadedOrgs: true,
            organizations: action.data.sortBy((org) => org.get('sort')),
        };
    },
    [actionTypes.GET_PEOPLE_SUCCESS]: (state, action) => {
        return {
            loadedPeople: true,
            people: action.data.map(getSessionPeople),
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<SessionBulkUpdateStore>(initialState(), actionsMap);
